module.exports = __webpack_public_path__ + "img/signup_carousel_2.fb423287.svg";